export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12125.d6dff583.jpg";